<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">按分类充值</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" v-loading="loading">

        <el-row>
          <el-col :span="24" class="item">
            {{infoStr}}
          </el-col>
        </el-row>
        <div style="height: 10px;"></div>
        <el-row>
          <el-col :span="24" class="item">
            每人充值:
            <el-input size="mini" v-model="elderlyClassValue" placeholder="输入充值金额" style="width: 150px;"></el-input>
            总金额:{{this.elderlyClassValue*this.totalItems}}
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">确认充值</el-button>
      </div>
    </div>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Add',
  data() {
    return {

      loading: false,
      showModal:false,

      elderlyClassCode:'',
      elderlyClassName:'',
      elderlyClassValue:0,
      zoneCode:'',
      zoneTitle:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      infoStr:'',

    }
  },
  components:{

  },
  methods: {
    init(classCode,classValue,className,zoneCode,zoneTitle){

      this.elderlyClassCode = classCode;
      this.elderlyClassValue = classValue;
      this.elderlyClassName = className;

      this.zoneCode = zoneCode;
      this.zoneTitle = zoneTitle;

      this.getElderly();

    },
    closeSelf() {
      this.$emit("closeAddMulConfirm");
    },

    getElderly(){

      let that = this;
      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/GovPageClassZone",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyClassCode:this.elderlyClassCode,
          zoneCode:this.zoneCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.loading = false;

            if (response.data.error == 0) {
              //this.tableData=response.data.data.pageInfo.list;
              that.totalItems = response.data.data.pageInfo.total;

              if(this.zoneCode == ''){
                if(this.elderlyClassCode == ''){
                  that.infoStr = "将要给全区域中全所有的 ["+that.totalItems+"] 位老人充值";
                }else{
                  that.infoStr = "将要给全区域中分类是 ["+that.elderlyClassName+"] 的 ["+that.totalItems+"] 位老人充值";
                }
              }else{
                if(this.elderlyClassCode == ''){
                  that.infoStr = "将要给区域 ["+that.zoneTitle+"] 中的 ["+that.totalItems+"] 位老人充值";
                }else{
                  that.infoStr = "将要给区域 ["+that.zoneTitle+"] 中分类是 ["+that.elderlyClassName+"] 的 ["+that.totalItems+"] 位老人充值";
                }
              }



            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }

          }
      )
    },

    confirm(){

      if(this.elderlyClassValue == '' || this.elderlyClassValue == 0){
        this.$message.info("输入正确的充值金额");
        return;
      }
      if(!this.isNumeric(this.elderlyClassValue)){
        this.$message.info("输入正确的充值金额");
        return;
      }

      if(this.totalItems == 0){
        this.$message.info("该分类下没有老人");
        return;
      }

      this.$confirm('确定充值?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addSubmit()
      }).catch(e=>e)


    },

    addSubmit(){

      this.showModal =true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Recharge/GovAddMul",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          elderlyClassCode:this.elderlyClassCode,
          zoneCode:this.zoneCode,
          addBalance:this.elderlyClassValue,
        }
      }).then(
          (response) => {

            this.showModal = false;

            if (response.data.error == 0) {
              this.$emit("closeAddMulConfirm");
              this.$emit("closeAndList");

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )


    },

    isNumeric (str) {
      var newPar = /^(-|\+)?\d+(\.\d+)?$/;
      return newPar.test(str);
    },

  }
}


</script>
<style lang="scss" scoped>

.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;

}

.label{
  padding: 5px 0px;
}
</style>
